const CANVAS_LEFT_RAIL_COLLAPSED_LEFT = 16;
function getCanvasLeftRailLeft() {
  return CANVAS_LEFT_RAIL_COLLAPSED_LEFT;
}

export { getCanvasLeftRailLeft };
